import { TransformedData } from '@west-australian-newspapers/election-api-types'
import { DataLoaderGlobalParams } from '../resources'
import { httpGet } from '../../helpers/http'

function validateGetElectionDataResponse(value: any): TransformedData {
    const toValidate = value

    if (!toValidate) {
        throw new Error('Election API data missing')
    }

    return value
}

export function getElectionData(
    services: DataLoaderGlobalParams,
    electionId: number,
) {
    return httpGet({
        log: services.log,
        validate: validateGetElectionDataResponse,
        baseUrl: services.config.electionApi,
        path: `data/${electionId}`,
        customHeaders: {
            caller: services.config.apiCallerHeader,
        },
    })
}
